import { render, staticRenderFns } from "./EinstellungenSubventionen.vue?vue&type=template&id=81176cfe&"
import script from "./EinstellungenSubventionen.vue?vue&type=script&lang=js&"
export * from "./EinstellungenSubventionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports